/**
 * Server-side Copilot chat history — the durable replacement for localStorage.
 * Talks to CM's session-authed /cm/copilot/conversations endpoints (same auth
 * path as the Copilot token; no API key involved). Each call resolves to the
 * response data or throws, so the store can fall back gracefully.
 */
import makeApi from "Utils/apiURL";
import { SERVER_URL } from "Static/constant";

const BASE = `${SERVER_URL}/cm/copilot/conversations`;

// Create an empty chat; returns { id, title, createTs }.
export const createConversation = async title => {
  const res = await makeApi({
    url: BASE,
    method: "POST",
    data: { title: title || "" }
  });
  return res?.data || null;
};

// History drawer: this member's chats, newest first. Returns [{id,title,messageCount,lastActivityTs,createTs}].
export const listConversations = async (page = 1, limit = 30) => {
  const res = await makeApi({
    url: `${BASE}?page=${page}&limit=${limit}`,
    method: "GET"
  });
  return res?.data?.data || [];
};

// Full conversation (all messages) for opening /copilot/:id.
export const getConversation = async id => {
  const res = await makeApi({ url: `${BASE}/${id}`, method: "GET" });
  return res?.data || null;
};

// Upsert the thread after a change. Returns { id, messageCount, updateTs }.
export const saveConversation = async (id, title, messages, outcome) => {
  const res = await makeApi({
    url: `${BASE}/${id}`,
    method: "PUT",
    data: { title: title || "", messages: messages || [], ...(outcome || {}) }
  });
  return res?.data || null;
};

// Rename only — no messages in the body, so the stored thread is untouched
// (CM treats a null messages payload as a metadata-only update).
export const renameConversationApi = async (id, title) => {
  const res = await makeApi({
    url: `${BASE}/${id}`,
    method: "PUT",
    data: { title: title || "" }
  });
  return res?.data || null;
};

// Soft-delete.
export const deleteConversationApi = async id => {
  const res = await makeApi({ url: `${BASE}/${id}`, method: "DELETE" });
  return res?.data || null;
};
